/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  FormHelperText
} from "@mui/material";
import {
  Autorenew,
  Autorenew as AutorenewIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import { GridSearchIcon } from "@mui/x-data-grid";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import MDButton from "components/MDButton";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { appConstants } from "utils/appConstants";
import { showResMsg } from "utils/generic";
import { getScreenRight } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { deactivateClient } from "utils/superAdminApi";
import { getClients } from "utils/superAdminApi";
import { reactivateAccount } from "utils/superAdminApi";
import ShowSwalWithButtons from "components/SwalAlert/swalPopupWithButtons";

let searchParameter = "";
const SCREEN_NAME = "Clients";
let SCREEN_RIGHT = "None";
let featureStatus = "Active";

let businessUserStatus = 'Active';
let defaultPageIndex = 0;
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 24,
  p: 3,
  display: 'grid',
  justifyContent: 'start'
};

function Clients() {
  // const modalRef = useRef();
  const [customerReload, setCustomerReload] = useState(false);
  const [immediateChecked, setImmediateChecked] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [controller] = useMaterialUIController();
  const { sidenavColor, darkMode } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [disableColor, setDisableColor] = useState(false);
  const [title, setTitle] = useState("");
  const [deleteTypeValue, setDeleteTypeValue] = useState("onPlanExpire");
  const [helperText, setHelperText] = React.useState('User Account will deleted after subscription expires');
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [values, setValues] = React.useState({
    initialValue: '',
    finalValue: 10,
    businessUserStatus: 'All',
    _id: '',
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    sortingType: "",
    sortingField: "",
    searchParameterList: ['cancellationType', 'businessUserStatus', 'companyCity', 'phoneNumber', 'emailAddress', 'companyName',
      'planExpiryDate', 'planExpiryDate', 'planActivationDate', 'planName', 'customerName', 'planExpiryDateToString', 'planActivationDateToString'],
    searchParameter: '',
    searchParameter1: '',
  });


  useEffect(() => {
    fetchClients();
  }, [values.page, values.limit, values.sortingType, values.sortingField, values.businessUserStatus]);

  const fetchClients = async () => {
    getClients(values, (data) => {
      console.log("stedata", data.Result_Output)
      setTotalRows(data.Result_Output.totalDocs)
      setRows(data.Result_Output.docs)
    }, dispatch)
  };

  useEffect(() => {
    if (values.filterValues.length == "") {
      fetchClients();
    }
  }, [values.filterValues]);

  useEffect(() => {
    featureStatus = "Active";
    values.featureStatus = "Active";
    getRight();
  }, []);

  async function getRight() {
    let right = await getScreenRight("Business Users")
    if (right === "Full Access") setDisableColor(false)
    else setDisableColor(true)
  }
  useEffect(() => {
    searchParameter = values.searchParameter;
  }, [values.searchParameter]);
  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handlePageChange = page => {
    values.page = page;
    fetchClients();
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage
    setPerPage(newPerPage);
  };
  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
  };

  const deleteUserRequest = (id) => {

    deactivateClient({ data: id, type: deleteTypeValue }, (data) => {
      showResMsg(data.Result_Status ? genericMessage.deletedUser : data.Result_Message, 1000, data.Result_Status);
      setSelectedId("")
    }, dispatch)
  }
  const reactivateUserAccount = (selectedRow) => {
    ShowSwalWithButtons(
      'Are you sure?', `Would you like to Reactivate this User?`, 'warning', darkMode,
      () => {
        reactivateAccount({ userID: selectedRow._id }, (data) => {
          showResMsg(data.Result_Message, 2000, data.Result_Status);
          fetchClients();
        }, dispatch)
      }
    );
    // Swal.fire({
    //   title: "Are you sure?",
    //   text: "Would you like to Reactivate this User?",
    //   icon: "warning",
    //   showCancelButton: true,
    //   confirmButtonColor: "#4CAF50",
    //   cancelButtonColor: "#6c757d",
    //   confirmButtonText: "Yes",
    //   cancelButtonText: "No",
    //   reverseButtons: true,
    //   customClass: {
    //     title: darkMode ? 'swal-title-dark' : 'swal-title-light',
    //     popup: darkMode ? "darkPopup" : "whitePopup",

    //   },
    //   allowEnterKey: false, allowOutsideClick: false, allowEscapeKey: false,
    // }).then((result) => {
    //   if (result.isConfirmed) {
    //     reactivateAccount({ userID: selectedRow._id }, (data) => {
    //       showResMsg(data.Result_Message, 2000, data.Result_Status);
    //       fetchClients();

    //     }, dispatch)
    //   }
    // });

  }

  const handleDeleteType = (name) => event => {
    const radioValue = event.target.value;
    if (radioValue === "onPlanExpire") {
      setHelperText('User Account will deleted after subscription expires');
    } else if (radioValue === "Immediate") {
      setHelperText('User Account will deleted immediately, without waiting for subscription expires');
    }
    setDeleteTypeValue(event.target.value);
  }
  const handleImmediateCheckboxChange = (event) => {
    const checked = event.target.checked;
    if (checked) {
      setImmediateChecked(!immediateChecked);

    } else {
      setImmediateChecked(false);
    }
  };
  // const handleProfileDelete = (id) =>{
  //   Swal.fire({
  //     title: 'Delete Item',
  //     html: `
  //       <p>Are you sure you want to delete this item?</p>
  //       <button id="delete-confirm" class="swal2-confirm swal2-styled">Yes, delete it!</button>
  //       <button id="delete-cancel" class="swal2-cancel swal2-styled">No, cancel!</button>
  //       <button id="delete-other" class="swal2-other swal2-styled">Other action</button>
  //     `,
  //     showCancelButton: false,
  //     showConfirmButton: false,
  //     didOpen: () => {
  //       document.getElementById('delete-confirm').addEventListener('click', () => {
  //         Swal.close();
  //         deleteUserRequest(id)
  //         console.log('Delete confirmed');
  //       });

  //       document.getElementById('delete-cancel').addEventListener('click', () => {
  //         Swal.close();
  //         deleteUserRequest(id , )
  //         console.log('Delete cancelled');
  //       });

  //       document.getElementById('delete-other').addEventListener('click', () => {
  //         Swal.close();
  //         console.log('Other action');
  //       });
  //     }
  //   });
  // }
  const navigateTonfo = (id) => {
    navigate(`/clients/client_info/${id}`)
  }

  let businessCol = [
    {
      name: "Business User Name",
      selector: row => row.companyName,
      sortField: 'companyName',
      cell: (row) => (
        // <Button onClick={() => navigateTonfo(row.companyNameWithID.businessUserID)}>
        <div className={`${darkMode ? " username" : ""}`} onClick={() => navigateTonfo(row.companyNameWithID.businessUserID)}>

          <span
            //  style={darkMode && {borderBottom:"2px solid skyblue"}}
            style={darkMode ? { borderBottom: "2px solid skyblue" } : {}}
          >
            {row.companyName}</span>

        </div>
        // </Button>
      )
    },

    {
      name: "Subscription Plan",
      selector: row => row.planName,
      sortable: true,
      sortField: 'planName',
      center: true
    },
    {
      name: "Activation Date",
      selector: row => row.planActivationDateToString,
      sortable: true,
      sortField: 'planActivationDate',
      center: true
    },
    {
      name: "Expiry Date",
      selector: row => row.planExpiryDateToString,
      sortable: true,
      sortField: 'planExpiryDate',
      center: true
    },
    {
      name: "Email Address",
      selector: row => row.emailAddress,
      sortable: true,
      sortField: 'emailAddress',
      center: true
    },
    {
      name: "Mobile Number",
      selector: row => row.phoneNumber,
      sortable: true,
      sortField: 'phoneNumber',
      center: true
    },
    {
      name: "City",
      selector: row => row.companyCity,
      sortable: true,
      sortField: 'companyCity',
      center: true
    },
    {
      name: "Status",
      selector: row => row.businessUserStatus,
      sortable: true,
      sortField: 'businessUserStatus',

    },
    {
      name: "Action",
      selector: row => row.cancellationType,
      sortable: true,
      sortField: 'cancellationType',
      center: true,
      cell: (row) => (
        <>
          <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}>
            <Grid item>
              {row.businessUserStatus === "Delete" ?
                <TimelineItem color="error" icon={<DeleteIcon className="actionicon" />} title="Delete Account" onClick={() => setSelectedId(row)} /> :
                <TimelineItem color="grey" icon={<DeleteIcon className="actionicon" style={{ cursor: "not-allowed" }} />} title="Delete Account" />
              }
            </Grid>
            <Grid item>
              {row.businessUserStatus === "Delete" ?
                <TimelineItem color="success" icon={<Autorenew className="actionicon" />} title="Reactivate Account" onClick={() => reactivateUserAccount(row)} /> :
                <TimelineItem color="grey" icon={<Autorenew className="actionicon" style={{ cursor: "not-allowed" }} />} title="Reactivate Account" />
              }
            </Grid>
          </Grid>
        </>
      ),
    },

  ]
  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") { return; }
    setSelectedId("");
  };
  return (
    <DashboardLayout>
      <DashboardNavbar screenName={"Business Users"} />
      <div style={{ marginTop: '20px' }}>
        <Card color="primary">
          <PageTitle screenName="Business Users" />
          <Grid container display={"flex"} justifyContent="end" mt={2.2} gap={2} px={2.2}>
            <Grid lg={2.5} xs={6} >
              <FormControl fullWidth>
                <InputLabel id="Status">Filter By Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "44.11px" }}
                  label="Filter By Status"
                  value={values.businessUserStatus}
                  onChange={(e) => setValues({ ...values, businessUserStatus: e.target.value })}
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid lg={2.5} xs={6}>
              <TextField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={handleSearchFilter}
                onKeyUp={(e) => {
                  if (e.key === "Enter") fetchClients();
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment  >
                      <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={fetchClients}>
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
          <CardContent>
            <BTable
              title={title}
              columns={businessCol}
              data={rows}
              selectableRows={false}
              sortingType={handleSort}
              sortServer
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              fixedHeaderScrollHeight="410px"
              fixedHeader={true}

            />
          </CardContent>
        </Card>


        <Modal
          open={selectedId}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          disableEscapeKeyDown
        >
          <Card sx={style} className={darkMode ? "darkPopup" : "whitePopup"}>


            <Typography id="demo-controlled-radio-buttons-group" style={{ fontSize: "20px", fontWeight: "bold", color: "red" }}>Choose delete option</Typography>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={deleteTypeValue}
              onChange={handleDeleteType("deleteType")}
            >
              <FormControlLabel value="onPlanExpire" control={<Radio />} label="After Subscription Expire" />
              <FormControlLabel value="Immediate" control={<Radio />} label="Immediate" />
            </RadioGroup>

            <FormHelperText sx={{ color: 'red', height: "20px" }}>{helperText}</FormHelperText>
            <Grid gap={2} sx={{ mt: 2, display: "flex", justifyContent: "center", width: 350 }}>
              <Grid item>
                <MDButton color="secondary" onClick={() => setSelectedId("")} style={{ width: "64px", textTransform: "capitalize" }}>
                  Cancel
                </MDButton></Grid>
              <Grid item>
                <MDButton color="error" onClick={() => deleteUserRequest(selectedId)} style={{ width: "64px", textTransform: "capitalize" }}>
                  Delete
                </MDButton></Grid>
            </Grid>
          </Card>
        </Modal>
      </div>
    </DashboardLayout>
  );

  // console.log("dfnjkdsnfjnsdjkf",)
}

export default Clients;
